import React, { Component } from 'react';
import { SubmissionError, reduxForm } from 'redux-form';
import TransitionedBlock from '../../../HelperComponents/TransitionedBlock/TransitionedBlock';
import BackLink from '../../../BackLink/BackLink';
import DefaultButton from '../../../Buttons/DefaultButton/DefaultButton';
import IconDeleteFile from '../../../../assets/image/delete_file.png';
import Iconfile from '../../../../assets/image/file.png';
import IconAttach from '../../../../assets/image/attach.png';
import './RequestsAdd.scss';
import IncreaseIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import {isArray} from "../../../../helpers/functions";
import {bindActionCreators} from "redux";
import {postCreateRequest, searchResiduesByDocumentNumber} from "../../../../actions/PurchasesActions";
import {connect} from "react-redux";
import ErrorIcon from '@material-ui/icons/Error';
import TooltipMessage from '../../../HelperComponents/TooltipMessage/TooltipMessage';
import moment from 'moment';

const initialActiveItem = { amount: 1, price: 0, id: 0, lot: 0, name: '-', producer: '-', article_number: '-' };

class RequestsAdd extends Component {

    state = {
        value: '',
        activePage: 1,
        openModal: false,
        initSearch: false,
        results: {data: [], query: ''},
        hasResults: false,
        files: [],
        activeItem: initialActiveItem,
        requestAmount: 1,
        requestSum: 0,
        addDisabled: false,
        reDisabled: false,
        loading: false,
        comment: '',
        disabledBtn: true,
        showToast: false,
        documentNumberValue: '',
        documentResults: { data: [], query: '' },
        initDocumentSearch: false,
        selectedDocument: null,
        cartOrders: [],
        articleNumberValue: '',
    };

    debounceTimeout = null;

    handleDocumentNumberChange = (e) => {
        const value = e.target.value;
        this.setState({ documentNumberValue: value });
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
            this.handleDocumentNumberSearch();
        }, 400);
    };

    handleDocumentNumberSearch = () => {
        const { documentNumberValue } = this.state;
        if (documentNumberValue.length >= 2) {
            this.props.dispatch(searchResiduesByDocumentNumber(documentNumberValue)).then((res) => {
                const data = (res && res.payload && res.payload.data) ? res.payload.data : [];
                this.setState({ initDocumentSearch: true, documentResults: { data, query: documentNumberValue } });
            });
        } else if (documentNumberValue.length < 2) {
            this.setState({ initDocumentSearch: false });
        }
    };

    handleSelectDocument = (item) => {
        this.setState({
            activeItem: initialActiveItem,
            documentNumberValue: item.document_number,
            documentResults: { data: [], query: '' },
            initDocumentSearch: false,
            selectedDocument: item,
            cartOrders: [],
        });
    };

    handleAddToCart = (order) => {
        this.setState((prevState) => {
            if (prevState.cartOrders.find(o => o.id === order.id)) return null;
            return { cartOrders: [...prevState.cartOrders, { ...order, selectedAmount: 1 }] };
        });
    };

    handleRemoveFromCart = (orderId) => {
        this.setState((prevState) => ({
            cartOrders: prevState.cartOrders.filter(order => order.id !== orderId)
        }));
    };

    handleCartAmountChange = (orderId, delta) => {
        this.setState((prevState) => ({
            cartOrders: prevState.cartOrders.map(order => {
                if (order.id !== orderId) return order;
                const max = order.amount;
                let next = order.selectedAmount + delta;
                if (next < 1) next = 1;
                if (next > max) next = max;
                return { ...order, selectedAmount: next };
            })
        }));
    };

    onChangeComment = (e) => {
        const value = e.target.value;
        this.setState({
            comment: value,
        });
    };

    componentDidUpdate(prevProps, prevState) {
        const { comment, cartOrders } = this.state;
        const hasComment = comment && comment.trim().length > 0;
        const hasSelectedOrders = cartOrders && cartOrders.length > 0;
        const shouldBeDisabled = !hasComment || !hasSelectedOrders;
        
        if (prevState.disabledBtn !== shouldBeDisabled) {
            this.setState({ disabledBtn: shouldBeDisabled });
        }
    }

    submitForm = () => {
        this.setState({ loading: true });
        const { files, comment, selectedDocument, cartOrders } = this.state;
        const { postCreateRequest, history } = this.props;

        const ordersData = cartOrders.map(order => ({
            order: order.id,
            amount: order.selectedAmount,
            price: order.price * order.selectedAmount
        }));

        const formData = new FormData();

        files.forEach(file => formData.append('files', file, file.name));
        formData.append('comment', comment);
        formData.append('ordernum', null);
        formData.append('document_number', selectedDocument ? selectedDocument.id : '');
        formData.append('orders', JSON.stringify(ordersData));

        return postCreateRequest(formData).then(res => {
            if (res && res.payload && res.payload.status === 201) {
                this.setState({ loading: false });
                history.push({pathname: '/admin/purchases', search: `tab=2&success=true`});
            } else {
                this.setState({ loading: false });
                throw new SubmissionError({
                    ...res.error.response.data,
                    _error: (res && res.error && res.error.response && res.error.response.data && res.error.response.data.error && res.error.response.data.error[0]) || 'Произошла ошибка. Повторите попытку позже.'
                });
            }
        });
    };

    handleArticleNumberChange = (e) => {
        const value = e.target.value;
        this.setState({ articleNumberValue: value });
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
            this.handleArticleNumberSearch();
        }, 400);
    };

    handleArticleNumberSearch = () => {
        const { documentNumberValue, articleNumberValue } = this.state;
        if (documentNumberValue && articleNumberValue.length > 0) {
            this.props.dispatch(searchResiduesByDocumentNumber(documentNumberValue, articleNumberValue)).then((res) => {
                const data = (res && res.payload && res.payload.data) ? res.payload.data : [];
                this.setState({ documentResults: { data, query: documentNumberValue }, selectedDocument: data.find(d => d.document_number === documentNumberValue) || null });
            });
        } else if (documentNumberValue && articleNumberValue.length === 0) {
            this.props.dispatch(searchResiduesByDocumentNumber(documentNumberValue)).then((res) => {
                const data = (res && res.payload && res.payload.data) ? res.payload.data : [];
                this.setState({ documentResults: { data, query: documentNumberValue }, selectedDocument: data.find(d => d.document_number === documentNumberValue) || null });
            });
        }
    };

    onChangeFile(e) {
        this.setState({files: this.state.files.concat(e.target.files[0])})
        e.target.value = ''
    }

    removeFile(index) {
        let array = [...this.state.files];
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({files: array});
        }
    }

    toggleSnack = () => {
        this.setState(({success}) => ({
            success: false
        }));
    };

    onChange = (e) => {
        let value = e.target.value.replace(/\D/g,'');
        this.setState({ value: value });
    };
    
    onClickAttach = (e) => {
        e.preventDefault()
        this.upload.click()
    };

    render() {
        const { handleSubmit, error } = this.props;
        const {files, disabledBtn, loading, comment, documentNumberValue, documentResults, initDocumentSearch, selectedDocument, cartOrders, articleNumberValue} = this.state;
        return (
            <form onSubmit={handleSubmit(this.submitForm)}>
                <div className="container requests_add_page">
                    <div className="title-block">
                        <BackLink to={'/admin/purchases?tab=2'}/>
                        <h1>Создать заявку на возврат</h1>
                        <TransitionedBlock>
                            <div className="requests_add">
                                <div className="requests_add_search">
                                    <div className="requests_add_search_header">
                                        <span>Номер УПД</span>
                                        <TooltipMessage
                                            text="Номер документа состоит из символов кириллицы"
                                            delay={500}
                                            position="top"
                                            classes='tooltip_message_refund'
                                        >
                                            <InfoIcon className="info_icon" />
                                        </TooltipMessage>
                                    </div>
                                    <input
                                        type="text"
                                        className='requests_add_search-input'
                                        placeholder="Введите номер УПД"
                                        value={documentNumberValue}
                                        onChange={this.handleDocumentNumberChange}
                                        autoComplete="off"
                                    />
                                    {initDocumentSearch &&
                                        <div className="search_products_list">
                                            {isArray(documentResults.data) ? documentResults.data.map((item) => (
                                                <div className="search_product_item" key={item.id} onClick={() => this.handleSelectDocument(item)}>
                                                    <div className="search_product_item_head">
                                                        <span>{item.document_number}</span>
                                                    </div>
                                                    <div className="search_product_item_info">
                                                        <span className="block_label">Дата выдачи</span>
                                                        <p className="block_value">
                                                            {moment(item.date).format("DD.MM.YYYY HH:mm")}
                                                        </p>
                                                        <div></div>
                                                    </div>
                                                </div>
                                            )) : <li>Нет совпадений</li>}
                                        </div>
                                    }
                                </div>
                                {selectedDocument && (
                                    <div className="requests_add_search">
                                        <span>Артикул</span>
                                        <input
                                            type="text"
                                            className='requests_add_search-input'
                                            placeholder="Введите артикул"
                                            value={articleNumberValue}
                                            onChange={this.handleArticleNumberChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                )}
                                {selectedDocument && Array.isArray(selectedDocument.orders) && (
                                    <div className="orders_scroll_list">
                                        {selectedDocument.orders.length === 0 ? (
                                            <div className="orders_scroll_list_empty">Ничего не найдено</div>
                                        ) : (
                                            selectedDocument.orders.map(order => {
                                                const isInCart = cartOrders.some(o => o.id === order.id);
                                                return (
                                                    <div className="order_item order_item_overlayable" key={order.id}>
                                                        <div className="order_item_content">
                                                            <div className="order_item_row">
                                                                <span className="block_label">Товар</span>
                                                                <span className="block_value">{order.name}</span>
                                                            </div>
                                                            <div className="order_item_row">
                                                                <span className="block_label">Артикул</span>
                                                                <span className="block_value">{order.article_number}</span>
                                                            </div>
                                                            <div className="order_item_row">
                                                                <span className="block_label">Производитель</span>
                                                                <span className="block_value">{order.producer}</span>
                                                            </div>
                                                            <div className="order_item_row">
                                                                <span className="block_label">Количество</span>
                                                                <span className="block_value">{order.amount}</span>
                                                            </div>
                                                            <div className="order_item_row">
                                                                <span className="block_label">Цена</span>
                                                                <span className="block_value">{order.price} ₽</span>
                                                            </div>
                                                        </div>
                                                        {isInCart ? (
                                                            <div className="order_item_overlay order_item_overlay_selected" onClick={() => this.handleRemoveFromCart(order.id)}>
                                                                <CheckCircleIcon className="order_item_overlay_icon_selected" />
                                                                <CloseIcon className="order_item_overlay_icon_remove" />
                                                            </div>
                                                        ) : (
                                                            <div className="order_item_overlay" onClick={() => this.handleAddToCart(order)}>
                                                                <AddCircleOutlineIcon className="order_item_overlay_icon" />
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                )}
                                {cartOrders.length > 0 && (
                                    <div className="cart_orders_list">
                                        <div className="cart_orders_title">Выбрано</div>
                                        {cartOrders.map(order => (
                                            <div className="order_item" key={order.id}>
                                                <div className="order_item_row">
                                                    <span className="block_label">Товар</span>
                                                    <span className="block_value">{order.name}</span>
                                                    <button type="button" className="cart_remove_btn" onClick={() => this.handleRemoveFromCart(order.id)}><CloseIcon /></button>
                                                </div>
                                                <div className="order_item_row">
                                                    <span className="block_label">Артикул</span>
                                                    <span className="block_value">{order.article_number}</span>
                                                </div>
                                                <div className="order_item_row">
                                                    <span className="block_label">Производитель</span>
                                                    <span className="block_value">{order.producer}</span>
                                                </div>
                                                <div className="order_item_row">
                                                    <span className="block_label">Количество</span>
                                                    <div className="cart_stepper">
                                                        <button type="button" className="cart_stepper_btn" onClick={() => this.handleCartAmountChange(order.id, -1)} disabled={order.selectedAmount <= 1}><RemoveIcon /></button>
                                                        <span className="cart_stepper_value">{order.selectedAmount}</span>
                                                        <button type="button" className="cart_stepper_btn" onClick={() => this.handleCartAmountChange(order.id, 1)} disabled={order.selectedAmount >= order.amount}><IncreaseIcon /></button>
                                                        <span className="cart_stepper_max">/ {order.amount}</span>
                                                    </div>
                                                </div>
                                                <div className="order_item_row">
                                                    <span className="block_label">Цена</span>
                                                    <span className="block_value">{order.price} ₽</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                <div className="block_textarea_amount">
                                    <span>Комментарий</span>
                                    <textarea placeholder="Ваш комментарий" onChange={this.onChangeComment}
                                            value={comment}></textarea>
                                </div>
                                <div className="attach_file_block">
                                    <input type="file" hidden={true} ref={(ref) => this.upload = ref}
                                        onChange={(e) => this.onChangeFile(e)}/>
                                    <button type="button" className="attach_btn" onClick={(e) => this.onClickAttach(e)}>
                                        <img src={IconAttach} alt="IconAttach"/>
                                        Прикрепить файл
                                    </button>
                                    {files.map((file, index) => {
                                        return (
                                            <div className="document_info" key={index}>
                                                <img className="doc_icon" src={Iconfile} alt="Iconfile"/>
                                                <span>{file.name}</span>
                                                <button type="button" className="btn_delete_doc"
                                                        onClick={(e) => this.removeFile(index)}>
                                                    <img src={IconDeleteFile} alt="IconDeleteFile"/>
                                                </button>
                                            </div>)
                                    })}

                                </div>
                                <div className="btn-wrapper">
                                    <DefaultButton
                                        variant="outlined"
                                        classes="cancel_btn"
                                        type="link"
                                        to="/admin/purchases?tab=2"
                                    >
                                        Отмена
                                    </DefaultButton>
                                    <DefaultButton
                                        loading={loading}
                                        disabled={disabledBtn}
                                        formAction
                                        variant="contained"
                                    >
                                        Создать заявку
                                    </DefaultButton>
                                    <div className="select_error_tooltip">
                                    {error && error !== null &&
                                        <TooltipMessage
                                            text={error}
                                            delay={200}
                                            error
                                        >
                                            <ErrorIcon/>
                                        </TooltipMessage>
                                    }
                                    </div>
                                </div>
                            </div>
                        </TransitionedBlock>
                    </div>
                    </div>
                </form>
        );
    }
}


RequestsAdd = reduxForm({
    form: "RequestsAddForm",
})(RequestsAdd);

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        postCreateRequest,
        searchResiduesByDocumentNumber
    }, dispatch);
}


export default connect(null, mapDispatchToProps)(RequestsAdd);